import global from 'window-or-global'
import DK from '../lang-values/DK'

const getTexts = () => {
    return DK || global.T
}

export default getTexts
